import React, { useState, useEffect, useCallback } from 'react'
import { get } from '../../data/api.js'
import { Table, TableRow, TableCell, TableBody, TableHead } from '@material-ui/core'
import ImageSupplierPattern from './ImageSupplierPattern.js'
import AddImageSupplierPattern from './AddImageSupplierPattern.js'

export default function ImageSupplierPatterns(props) {
	const { clientId } = props

	const [patternDomains, setPatternDomains] = useState([])

	const fetchPatternDomains = useCallback(async () => {
		const clientIncludeDomainPattern = await getImageSupplierPatterns(clientId)
		const formatSupplierDomain = clientIncludeDomainPattern.map(imageSupplierPattern =>({
			id: imageSupplierPattern.pattern_id,
			pattern: imageSupplierPattern.pattern,
			domains: imageSupplierPattern.domains.toString(),
		}))
		setPatternDomains(formatSupplierDomain)
	}, [clientId])

	useEffect(() => {
		fetchPatternDomains()
	}, [clientId, fetchPatternDomains])

	return (
		<div className='settings-table'>
			<p>Include violations with images according to supplier pattern within domain</p>
			<Table>
				<colgroup>
					<col width='33%' />
					<col width='33%' />
					<col width='33%' />
				</colgroup>
				<TableHead>
					<TableRow>
						<TableCell>Images supplier pattern</TableCell>
						<TableCell>Domains to include</TableCell>
						<TableCell></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{patternDomains.length ?
						patternDomains.map(row => (
							<ImageSupplierPattern
								fetchPatternDomains={fetchPatternDomains}
								clientId={clientId}
								id={row.id}
								pattern={row.pattern}
								domains={row.domains}
							/>
						)) : (
							<TableRow>
								<TableCell><p>No pattern/domains are defined</p></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
							</TableRow>
						)
					}
					<AddImageSupplierPattern clientId={clientId} fetchPatternDomains={fetchPatternDomains} />
				</TableBody>
			</Table>
		</div>
	)
}

function getImageSupplierPatterns(client_id) {
	return get(
		`/include-domains/image-supplier-patterns/?clientId=${client_id}`,
		'GET',
	)
}
